module.exports = __webpack_public_path__ + "img/新增入库.6dccec31.png";